import { gql } from "@apollo/client";

export const VALIDATE_AND_SYNC_SHOPIFY = gql`
mutation ValidateAndSyncShopify($input: SyncShopifyInput!) {
  validateAndSyncShopify(input: $input) {
    isShopifyConnected 
    message 
  }
}
`;
